import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.ip.management.offices.item');
import { CONTACT_EMAIL_PATTERN } from "src/libs/portal/season/contact-policy";
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const WizRoute: any;

@Component({
    selector: 'wiz-page-ip-management-offices-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.ip.management.offices.item/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageIpManagementOfficesItemComponent implements OnInit, OnDestroy {
    public detail: any = null;
    public status: any = null;
    public loading = true;
    public busy = false;
    public errorMessage = '';
    public actionError = '';
    public message = '';
    public invitationUrl = '';
    public primaryAdminEmail = '';
    public primaryAdminName = '';
    public primaryAdminPhone = '';
    public processingBasis = '';
    public editingPlan = false;
    public selectedPlanCode = '';
    public planSaving = false;
    public importPolicy: any = null;
    public importPolicyLoading = false;
    public importPolicySaving = false;
    public importPolicyError = '';
    public importPolicyReason = '';
    public dispatchProfile: any = null;
    public dispatchProfileLoading = false;
    public dispatchProfileSaving = false;
    public dispatchProfileError = '';
    public dispatchRecipientName = '';
    public dispatchRecipientEmail = '';
    public dispatchRecipientPhone = '';
    public dispatchAmountKrw: any = '';
    public planOptions = [
        { code: 'IP-MGMT-A', label: 'A타입', people: '3명 이내', price: '월 100,000원' },
        { code: 'IP-MGMT-B', label: 'B타입', people: '6명 이내', price: '월 150,000원' },
        { code: 'IP-MGMT-C', label: 'C타입', people: '10명 이내', price: '월 200,000원' },
        { code: 'IP-MGMT-D', label: 'D타입', people: '10명 초과', price: '월 200,000원 + 초과 1인당 10,000원' }
    ];
    private keys: any = {};
    private timer: any = null;
    private destroyed = false;

    constructor(@Inject( Service) public service: Service) {}

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        await this.load();
        this.timer = setInterval(() => {
            if (this.status && ['PROVISIONING', 'INVITED'].includes(this.status.status) && !this.busy) {
                this.refreshStatus();
            }
        }, 15000);
    }

    public ngOnDestroy() {
        this.destroyed = true;
        if (this.timer) clearInterval(this.timer);
        this.invitationUrl = '';
        this.primaryAdminEmail = '';
        this.primaryAdminName = '';
        this.primaryAdminPhone = '';
    }

    public planLabel(code: string): string {
        return this.planOptions.find((item) => item.code === code)?.label || code || '-';
    }

    public planOption(code: string): any {
        return this.planOptions.find((item) => item.code === code) || null;
    }

    public get selectedPlan(): any {
        return this.planOption(this.selectedPlanCode);
    }

    public get canChangePlan(): boolean {
        return ['DRAFT', 'APPROVED', 'INVITED', 'ACTIVE'].includes(this.currentStatus);
    }

    public get currentStatus(): string {
        return this.status?.status || this.detail?.provisioning?.status || '';
    }

    public get canManageImportPolicy(): boolean {
        return this.currentStatus === 'ACTIVE' && !!this.status?.tenant_id;
    }

    public get importPolicyAllowed(): boolean {
        return this.importPolicy?.import_allowed === true;
    }

    public get dispatchRecipientReady(): boolean {
        return this.dispatchProfile?.recipient_ready === true;
    }

    public get dispatchQuoteReady(): boolean {
        return this.dispatchProfile?.quote_ready === true;
    }

    public get dispatchPricingSourceLabel(): string {
        const labels: Record<string, string> = {
            CONTRACT: '계약 확정 금액',
            PLAN_CATALOG: '계약 타입 기본 금액',
            UNAVAILABLE: '금액 미등록'
        };
        return labels[String(this.dispatchProfile?.pricing?.source || '')] || '금액 미등록';
    }

    public statusLabel(value: string): string {
        const labels: Record<string, string> = {
            DRAFT: '계약 승인 대기',
            APPROVED: '개통 요청 대기',
            PROVISIONING: 'IP 관리에 사무소 등록 중',
            INVITED: '담당자 초대 단계',
            ACTIVE: '사용 가능',
            FAILED: '확인 필요',
            SUSPENDED: '이용 일시 중지',
            TERMINATED: '이용 종료'
        };
        return labels[value] || '상태 확인 중';
    }

    public contractStatusLabel(value: string): string {
        const labels: Record<string, string> = {
            DRAFT: '승인 전',
            APPROVED: '승인 완료',
            ACTIVE: '이용 중',
            SUSPENDED: '일시 중지',
            TERMINATED: '종료'
        };
        return labels[value] || '확인 중';
    }

    public get statusDescription(): string {
        const descriptions: Record<string, string> = {
            DRAFT: '계약 내용을 확인한 뒤 승인해주세요. 승인하면 개통 요청도 자동으로 접수됩니다.',
            APPROVED: '계약 승인이 끝났습니다. IP 관리 시스템에 이 사무소를 등록하려면 개통을 요청해주세요.',
            PROVISIONING: '개통 요청이 접수되었습니다. Core API가 IP 관리 시스템에 이 사무소를 등록하는 자동 작업의 상태를 확인하고 있습니다.',
            INVITED: '사무소용 이용 공간이 준비되었습니다. 초대 링크를 담당자에게 전달하고 수락을 기다려주세요.',
            ACTIVE: '개통이 완료되어 IP 관리 서비스를 사용할 수 있습니다.',
            FAILED: '개통 처리 중 문제가 발생했습니다. 초기 관리자 정보와 아래 오류 내용을 확인한 뒤 다시 요청해주세요.',
            SUSPENDED: '현재 서비스 이용이 일시 중지되어 있습니다.',
            TERMINATED: '서비스 이용이 종료되었습니다.'
        };
        return descriptions[this.currentStatus] || '최신 상태를 확인해주세요.';
    }

    public get serviceUseLabel(): string {
        if (this.currentStatus === 'ACTIVE') return '이용 가능';
        if (this.currentStatus === 'SUSPENDED' || this.currentStatus === 'TERMINATED') return '이용 불가';
        return '아직 이용 불가';
    }

    public get actionHeading(): string {
        if (this.currentStatus === 'PROVISIONING') return '시스템이 자동으로 처리 중';
        if (this.currentStatus === 'ACTIVE') return '개통 완료';
        if (this.currentStatus === 'SUSPENDED' || this.currentStatus === 'TERMINATED') return '이용 상태';
        return '다음에 할 일';
    }

    public get serviceUseDescription(): string {
        if (this.currentStatus === 'ACTIVE') return '담당자가 IP 관리 서비스를 사용할 수 있습니다.';
        if (this.currentStatus === 'INVITED') return '담당자가 초대를 수락하면 사용할 수 있습니다.';
        if (this.currentStatus === 'PROVISIONING') return '사무소 등록이 끝나면 담당자를 초대할 수 있습니다.';
        return 'IP 관리 연결과 담당자 초대가 끝나면 사용할 수 있습니다.';
    }

    public get contractPeriod(): string {
        const start = this.detail?.contract?.effective_from;
        const end = this.detail?.contract?.effective_until;
        return start || end ? `${start || '시작일 미정'} ~ ${end || '종료일 미정'}` : '아직 정해지지 않음';
    }

    public deliveryStatusLabel(value: string): string {
        const labels: Record<string, string> = {
            PENDING: '요청 대기 중',
            DISPATCHING: 'IP 관리 시스템에 요청 전달 중',
            SENDING: 'IP 관리 시스템에 요청 전달 중',
            POLLING: 'IP 관리 시스템의 처리 결과 확인 중',
            RETRY: '자동 재시도 중',
            RETRYING: '자동 재시도 중',
            COMPLETE: 'IP 관리 시스템 처리 완료',
            DEAD: '자동 처리 실패'
        };
        return labels[value] || '자동 처리 상태 확인 중';
    }

    public get processingMessage(): string {
        const state = this.status?.delivery?.state;
        const messages: Record<string, string> = {
            PENDING: '개통 요청이 Core API에 대기 중입니다. IP 관리 시스템으로 전달됐는지 확인이 필요합니다.',
            DISPATCHING: 'IP 관리 시스템에 사무소 등록 요청을 전달하고 있습니다.',
            SENDING: 'IP 관리 시스템에 사무소 등록 요청을 전달하고 있습니다.',
            POLLING: 'IP 관리 시스템에 요청을 전달했습니다. 사무소 등록 결과를 확인하고 있습니다.',
            RETRY: '일시적인 연결 문제로 시스템이 자동으로 다시 시도하고 있습니다.',
            RETRYING: '일시적인 연결 문제로 시스템이 자동으로 다시 시도하고 있습니다.',
            COMPLETE: 'IP 관리 시스템의 처리가 끝났습니다. 다음 상태를 확인하고 있습니다.',
            DEAD: '자동 처리가 완료되지 않았습니다. 오류 내용을 확인해주세요.'
        };
        return messages[state] || '개통 요청이 접수되었습니다. 시스템이 처리 상태를 확인하고 있습니다.';
    }

    public get deliveryAttempts(): number | null {
        const raw = this.status?.delivery?.dispatch_attempts;
        if (raw === null || raw === undefined || raw === '') return null;
        const attempts = Number(raw);
        return Number.isFinite(attempts) ? attempts : null;
    }

    public get requestElapsedMinutes(): number | null {
        const requestedAt = this.status?.requested_at;
        if (!requestedAt) return null;
        const started = new Date(requestedAt).getTime();
        if (Number.isNaN(started)) return null;
        return Math.floor(Math.max(0, Date.now() - started) / 60000);
    }

    public get pendingAdvice(): string {
        if (this.deliveryAttempts === 0) {
            return 'IP 관리 시스템에 전달한 기록이 아직 없습니다. Core API의 자동 처리 작업이 실행 중인지 확인해야 합니다.';
        }
        if (this.deliveryAttempts !== null && this.deliveryAttempts > 0) {
            return 'IP 관리 시스템으로 전달을 시도했지만 완료되지 않았습니다. 최근 오류와 다음 시도 시각을 확인해주세요.';
        }
        return '전달 시도 정보가 보이지 않습니다. Core API의 자동 처리 작업 상태를 확인해야 합니다.';
    }

    public get deliveryLastError(): string {
        const error = this.status?.delivery?.last_error;
        if (!error) return '';
        if (typeof error === 'string') return error;
        return String(error.message || error.code || '오류가 기록되었습니다.');
    }

    public get requestElapsed(): string {
        const requestedAt = this.status?.requested_at;
        if (!requestedAt) return '';
        const started = new Date(requestedAt).getTime();
        if (Number.isNaN(started)) return '';
        const minutes = Math.floor(Math.max(0, Date.now() - started) / 60000);
        if (minutes < 1) return '1분 미만';
        if (minutes < 60) return `${minutes}분`;
        return `${Math.floor(minutes / 60)}시간 ${minutes % 60}분`;
    }

    public get currentStepIndex(): number {
        const positions: Record<string, number> = {
            DRAFT: 1,
            APPROVED: 2,
            PROVISIONING: 2,
            INVITED: 3,
            ACTIVE: 4,
            FAILED: this.status?.last_action === 'PROVISION' ? 2 : 1,
            SUSPENDED: 4,
            TERMINATED: 4
        };
        return positions[this.currentStatus] ?? -1;
    }

    public steps = ['사무소 등록', '계약 승인', 'IP 관리에 사무소 등록', '담당자 초대', '사용 시작'];

    public historyLabel(event: any): string {
        if (event?.event_type === 'ONBOARDING_REGISTERED') return '사무소 등록';
        const labels: Record<string, string> = {
            DRAFT: '사무소 등록',
            APPROVED: '계약 승인',
            PROVISIONING: 'IP 관리 시스템에 사무소 등록 요청',
            INVITED: '담당자 초대 단계',
            ACTIVE: '서비스 사용 시작',
            FAILED: '처리 중 문제 발생',
            SUSPENDED: '이용 일시 중지',
            TERMINATED: '이용 종료'
        };
        return labels[event?.to_status] || '진행 상황 변경';
    }

    public historyReason(event: any): string {
        const reason = String(event?.reason || '').trim();
        const labels: Record<string, string> = {
            '특허사무소와 계약 온보딩 등록': '사무소와 계약 등록',
            'PROVISION 요청': 'IP 관리 시스템에 사무소 등록 요청',
            'IP 관리 status polling 동기화': 'IP 관리 시스템에서 상태 확인'
        };
        const text = labels[reason] || reason;
        return text === this.historyLabel(event) ? '' : text;
    }

    public formatDate(value: string): string {
        if (!value) return '-';
        const date = new Date(value);
        return Number.isNaN(date.getTime()) ? value : date.toLocaleString('ko-KR');
    }

    private get id(): string {
        return String(WizRoute?.segment?.id || '');
    }

    private unwrap(response: any, fallback: string): any {
        let envelope: any = response?.responseJSON || response;
        if (!response?.responseJSON && typeof response?.responseText === 'string') {
            try {
                envelope = JSON.parse(response.responseText);
            } catch (_error) {
                // Keep the safe fallback for non-JSON server responses.
            }
        }
        const code = Number(envelope?.code ?? response?.status ?? 0);
        if (code >= 200 && code < 300) return envelope?.data;
        const data = envelope?.data || envelope || {};
        const upstream = data?.error || envelope?.error || {};
        const message = upstream?.message || data?.message || envelope?.message
            || (code === 401 ? '관리자 로그인이 만료되었습니다. 다시 로그인한 뒤 요청해주세요.'
                : code === 403 ? '관리자 권한 또는 요청 출처를 확인할 수 없습니다. 다시 로그인한 뒤 요청해주세요.'
                : fallback + (code ? ' (응답 코드 ' + code + ')' : ' (서버 응답 없음)'));
        const error: any = new Error(message);
        error.code = upstream?.code || data?.error_code || envelope?.error_code || '';
        error.status = code;
        throw error;
    }

    private nextKey(action: string): string {
        if (!this.keys[action]) {
            const bytes = new Uint8Array(16);
            globalThis.crypto.getRandomValues(bytes);
            this.keys[action] = 'onboarding-' + Array.from(bytes).map(v => v.toString(16).padStart(2, '0')).join('');
        }
        return this.keys[action];
    }

    public async load() {
        this.loading = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const [detail, status] = await Promise.all([
                wiz.call('get_onboarding', { id: this.id }),
                wiz.call('get_onboarding_status', { id: this.id })
            ]);
            this.detail = this.unwrap(detail, '사무소 정보를 불러오지 못했습니다.');
            this.status = this.unwrap(status, '개통 상태를 불러오지 못했습니다.');
            await Promise.all([
                this.loadDispatchProfile(false),
                this.canManageImportPolicy ? this.loadImportPolicy(false) : Promise.resolve()
            ]);
        } catch (error: any) {
            this.errorMessage = error?.message || '사무소 정보를 불러오지 못했습니다.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async refreshStatus() {
        if (this.destroyed || this.busy) return;
        try {
            const previousStatus = this.currentStatus;
            const response = await wiz.call('get_onboarding_status', { id: this.id });
            this.status = this.unwrap(response, '개통 상태를 불러오지 못했습니다.');
            if (this.currentStatus !== previousStatus) {
                this.message = '';
                const detail = await wiz.call('get_onboarding', { id: this.id });
                this.detail = this.unwrap(detail, '진행 내역을 불러오지 못했습니다.');
                if (this.canManageImportPolicy) await this.loadImportPolicy(false);
            }
            this.errorMessage = '';
        } catch (error: any) {
            this.errorMessage = error?.message || '개통 상태를 불러오지 못했습니다.';
        }
        if (!this.destroyed) await this.service.render();
    }

    private async command(action: 'approve' | 'provision') {
        if (this.busy) return;
        this.busy = true;
        this.message = '';
        this.errorMessage = '';
        await this.service.render();
        try {
            const response = await wiz.call(
                action === 'approve' ? 'approve_onboarding' : 'provision_onboarding',
                { id: this.id, key: this.nextKey(action) }
            );
            this.detail = this.unwrap(response, '요청을 처리하지 못했습니다.');
            delete this.keys[action];
            this.status = this.detail?.provisioning || this.status;
            this.message = action === 'approve'
                ? '계약 승인이 끝났습니다. 이제 IP 관리 시스템에 사무소 등록을 요청해주세요.'
                : 'IP 관리 시스템에 사무소 등록을 요청했습니다. 시스템이 자동으로 처리한 뒤 담당자를 초대할 수 있습니다.';
        } catch (error: any) {
            this.errorMessage = error?.message || '요청을 처리하지 못했습니다. 상태를 확인한 뒤 다시 시도해주세요.';
        } finally {
            this.busy = false;
            await this.service.render();
        }
    }

    public async activate() {
        if (this.busy || !['DRAFT', 'APPROVED', 'FAILED'].includes(this.currentStatus)) return;
        if (!this.primaryAdminEmail.trim() || !this.processingBasis) {
            this.errorMessage = '초기 관리자 이메일과 개인정보 처리 근거를 입력해주세요.';
            await this.service.render();
            return;
        }
        const previousStatus = this.currentStatus;
        const primaryAdmin: any = { email: this.primaryAdminEmail.trim() };
        if (this.primaryAdminName.trim()) primaryAdmin.name = this.primaryAdminName.trim();
        if (this.primaryAdminPhone.trim()) primaryAdmin.phone = this.primaryAdminPhone.trim();
        const data = {
            primary_admin: primaryAdmin,
            personal_data_processing_basis: this.processingBasis
        };
        this.busy = true;
        this.message = '';
        this.errorMessage = '';
        this.actionError = '';
        await this.service.render();
        try {
            const endpoint = previousStatus === 'DRAFT' ? 'approve_onboarding' : 'provision_onboarding';
            const response = await wiz.call(endpoint, {
                id: this.id, data: JSON.stringify(data)
            });
            this.detail = this.unwrap(response, '계약 승인과 개통 요청을 처리하지 못했습니다.');
            this.status = this.detail?.provisioning || this.status;
            this.message = previousStatus === 'DRAFT'
                ? '계약 승인과 개통 요청이 접수되었습니다. 시스템이 사무소 등록을 자동으로 진행합니다.'
                : '개통 요청이 접수되었습니다. 시스템이 사무소 등록을 자동으로 진행합니다.';
            this.primaryAdminEmail = '';
            this.primaryAdminName = '';
            this.primaryAdminPhone = '';
        } catch (error: any) {
            try {
                const [detailResponse, statusResponse] = await Promise.all([
                    wiz.call('get_onboarding', { id: this.id }),
                    wiz.call('get_onboarding_status', { id: this.id })
                ]);
                this.detail = this.unwrap(detailResponse, '사무소 정보를 불러오지 못했습니다.');
                this.status = this.unwrap(statusResponse, '개통 상태를 불러오지 못했습니다.');
            } catch (_refreshError) {
                // Keep the original action error visible if Core status is also unavailable.
            }
            if (['PROVISIONING', 'INVITED', 'ACTIVE'].includes(this.currentStatus)) {
                this.actionError = '';
                this.errorMessage = '';
                this.message = '새 개통 작업이 접수되었습니다. 현재 상태를 확인해주세요.';
                this.primaryAdminEmail = '';
                this.primaryAdminName = '';
                this.primaryAdminPhone = '';
            } else {
                const reason = error?.message || '요청을 완료하지 못했습니다. 최신 상태를 확인한 뒤 다시 시도해주세요.';
                this.actionError = error?.code ? reason + ' (' + error.code + ')' : reason;
                this.errorMessage = this.actionError;
            }
        } finally {
            this.busy = false;
            await this.service.render();
        }
    }

    public approve() { return this.command('approve'); }
    public provision() { return this.command('provision'); }

    private applyDispatchProfile(item: any) {
        this.dispatchProfile = item || null;
        const recipient = item?.recipient || {};
        const pricing = item?.pricing || {};
        this.dispatchRecipientName = String(recipient.name || '');
        this.dispatchRecipientEmail = String(recipient.email || '');
        this.dispatchRecipientPhone = String(recipient.phone || '');
        this.dispatchAmountKrw = pricing.source === 'CONTRACT' && pricing.amount_krw != null
            ? String(pricing.amount_krw)
            : '';
    }

    private dispatchProfileErrorText(error: any, fallback: string): string {
        if (Number(error?.status || 0) === 403) {
            return 'Core API 관리자 토큰에 ONBOARDING_ADMIN 또는 SUPER_ADMIN 권한이 필요합니다.';
        }
        return error?.message || fallback;
    }

    public async loadDispatchProfile(render = true) {
        if (this.dispatchProfileLoading) return;
        this.dispatchProfileLoading = true;
        this.dispatchProfileError = '';
        if (render) await this.service.render();
        try {
            const response = await wiz.call('get_dispatch_recipient', { id: this.id });
            this.applyDispatchProfile(this.unwrap(response, '견적·안내 발송 정보를 불러오지 못했습니다.'));
        } catch (error: any) {
            this.dispatchProfileError = this.dispatchProfileErrorText(
                error, '견적·안내 발송 정보를 불러오지 못했습니다.'
            );
        } finally {
            this.dispatchProfileLoading = false;
            if (render && !this.destroyed) await this.service.render();
        }
    }

    public async saveDispatchProfile() {
        if (this.dispatchProfileSaving || this.dispatchProfileLoading) return;
        const email = this.dispatchRecipientEmail.trim().toLowerCase();
        if (email && !CONTACT_EMAIL_PATTERN.test(email)) {
            this.dispatchProfileError = '담당자 이메일 형식을 확인해주세요.';
            await this.service.render();
            return;
        }
        const amountText = String(this.dispatchAmountKrw ?? '').trim();
        if (amountText && !/^[1-9]\d*$/.test(amountText)) {
            this.dispatchProfileError = '월 견적은 0보다 큰 원 단위 정수로 입력해주세요.';
            await this.service.render();
            return;
        }

        this.dispatchProfileSaving = true;
        this.dispatchProfileError = '';
        this.message = '';
        await this.service.render();
        try {
            const response = await wiz.call('update_dispatch_recipient', {
                id: this.id,
                data: JSON.stringify({
                    recipient: {
                        name: this.dispatchRecipientName.trim() || null,
                        email: email || null,
                        phone: this.dispatchRecipientPhone.trim() || null
                    },
                    pricing: {
                        amount_krw: amountText ? Number(amountText) : null
                    }
                })
            });
            this.applyDispatchProfile(this.unwrap(response, '견적·안내 발송 정보를 저장하지 못했습니다.'));
            this.message = '담당자와 월 견적 정보를 저장했습니다. 견적/안내발송 화면에 즉시 반영됩니다.';
        } catch (error: any) {
            this.dispatchProfileError = this.dispatchProfileErrorText(
                error, '견적·안내 발송 정보를 저장하지 못했습니다.'
            );
        } finally {
            this.dispatchProfileSaving = false;
            await this.service.render();
        }
    }

    public async loadImportPolicy(render = true) {
        if (!this.canManageImportPolicy || this.importPolicyLoading) return;
        this.importPolicyLoading = true;
        this.importPolicyError = '';
        if (render) await this.service.render();
        try {
            const response = await wiz.call('get_import_policy', {
                tenant_id: String(this.status?.tenant_id || '')
            });
            this.importPolicy = this.unwrap(response, 'Excel Import 정책을 불러오지 못했습니다.');
        } catch (error: any) {
            this.importPolicyError = error?.message || 'Excel Import 정책을 불러오지 못했습니다.';
        } finally {
            this.importPolicyLoading = false;
            if (render && !this.destroyed) await this.service.render();
        }
    }

    public async changeImportPolicy() {
        if (!this.canManageImportPolicy || this.importPolicySaving) return;
        const reason = this.importPolicyReason.trim();
        if (!reason) {
            this.importPolicyError = '변경 사유를 입력해주세요.';
            await this.service.render();
            return;
        }

        const nextAllowed = !this.importPolicyAllowed;
        const confirmed = await this.service.modal.show({
            title: nextAllowed ? 'Excel Import 허용' : 'Excel Import 차단',
            message: nextAllowed
                ? '이 사무소에서 검증이 끝난 Excel 파일을 최종 반영할 수 있도록 허용하시겠습니까?'
                : '이 사무소의 Excel Import 최종 반영을 차단하시겠습니까?',
            action: nextAllowed ? '허용' : '차단',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!confirmed) return;

        this.importPolicySaving = true;
        this.importPolicyError = '';
        this.message = '';
        await this.service.render();
        try {
            const response = await wiz.call('set_import_policy', {
                tenant_id: String(this.status?.tenant_id || ''),
                data: JSON.stringify({
                    import_allowed: nextAllowed,
                    reason
                })
            });
            this.importPolicy = this.unwrap(response, 'Excel Import 정책을 변경하지 못했습니다.');
            this.importPolicyReason = '';
            this.message = nextAllowed
                ? '이 사무소의 Excel Import 최종 반영을 허용했습니다.'
                : '이 사무소의 Excel Import 최종 반영을 차단했습니다.';
        } catch (error: any) {
            this.importPolicyError = error?.message || 'Excel Import 정책을 변경하지 못했습니다.';
        } finally {
            this.importPolicySaving = false;
            await this.service.render();
        }
    }

    public async startPlanEdit() {
        if (!this.canChangePlan || this.busy) return;
        this.selectedPlanCode = String(this.detail?.contract?.plan_code || '');
        this.editingPlan = true;
        this.errorMessage = '';
        this.message = '';
        await this.service.render();
    }

    public async cancelPlanEdit() {
        if (this.planSaving) return;
        this.editingPlan = false;
        this.selectedPlanCode = '';
        await this.service.render();
    }

    public async savePlan() {
        if (!this.canChangePlan || this.busy || !this.selectedPlan) return;

        const currentCode = String(this.detail?.contract?.plan_code || '');
        const targetCode = this.selectedPlanCode;
        if (currentCode === targetCode) {
            await this.cancelPlanEdit();
            return;
        }

        const target = this.selectedPlan;
        const activeNotice = ['INVITED', 'ACTIVE'].includes(this.currentStatus)
            ? ' 이용 인원과 월 요금에 즉시 반영됩니다.'
            : '';
        const confirmed = await this.service.modal.show({
            title: '계약 타입 변경',
            message: this.planLabel(currentCode) + '에서 ' + target.label
                + '으로 변경하시겠습니까? ' + target.people + ', ' + target.price + '입니다.'
                + activeNotice,
            action: '변경',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!confirmed) return;

        this.busy = true;
        this.planSaving = true;
        this.errorMessage = '';
        this.message = '';
        await this.service.render();

        try {
            const response = await wiz.call('change_plan_onboarding', {
                id: this.id,
                data: JSON.stringify({
                    plan_code: targetCode,
                    effective: 'IMMEDIATE'
                })
            });
            const updated = this.unwrap(response, '계약 타입을 변경하지 못했습니다.');
            this.detail = updated;
            this.status = updated?.provisioning || this.status;
            this.editingPlan = false;
            this.selectedPlanCode = '';
            this.message = '계약 타입을 ' + target.label + '으로 변경했습니다.';
        } catch (error: any) {
            this.errorMessage = error?.message || '계약 타입을 변경하지 못했습니다.';
        } finally {
            this.busy = false;
            this.planSaving = false;
            await this.service.render();
        }
    }

    public async issueInvitation() {
        if (this.busy || this.status?.status !== 'INVITED') return;
        this.busy = true;
        this.invitationUrl = '';
        this.message = '';
        this.errorMessage = '';
        await this.service.render();
        try {
            const response = await wiz.call('create_invitation_link', {
                id: this.id, key: this.nextKey('invitation')
            });
            const data = this.unwrap(response, '초대 링크를 만들지 못했습니다.');
            this.invitationUrl = data.invitation_url || '';
            delete this.keys.invitation;
            this.message = '초대 링크를 만들었습니다. 아래 링크를 안전하게 전달하세요. 화면을 벗어나면 다시 볼 수 없습니다.';
        } catch (error: any) {
            this.errorMessage = error?.message || '초대 링크를 만들지 못했습니다.';
        } finally {
            this.busy = false;
            await this.service.render();
        }
    }

    public back() {
        this.invitationUrl = '';
        this.service.href('/ip-management/offices');
    }
}

export default PageIpManagementOfficesItemComponent;